import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import ColumnBase from "./ColumnBase";
import {defaultGroupRenderer} from "../../other/utils/utils.jsx";
import { ICON_COL_DEF_WIDTH } from "../../other/constants/OtherKeys.jsx";

export default class TaskScheduledColumn extends ColumnBase {
  static get $name() {
    return "TaskScheduledColumn";
  }

  static get type() {
    return WIDGET_KEYS.scheduledColumn;
  }

  static get defaults() {
    return {
      // text is used in the filter bar
      text: "Scheduled",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      field: "isTaskScheduled",
      editor: false,
      searchable: false,
      align: "center",
      cls: "swivu-icon-column",
      // prevent dropping columns to this one
      sealed: true,
      filterable: false,

      // in the header we want to see only icon
      headerRenderer() {
        return `<i class="fa-regular fa-calendar task-scheduled-icon" />`;
      },
      htmlEncode: false,
      renderer({ value }) {
        const style = value ? { color: "#0a88e9" } : {};
        return {
          children: [{ tag: "i",  class: "fa-regular fa-calendar", style }]
        };
      },
      groupRenderer({ groupRowFor, ...rest }) {
        const scheduledText = groupRowFor  ? "Scheduled Task": "Unscheduled Task";
        return defaultGroupRenderer({ groupRowFor: scheduledText, ...rest });
      },
    };
  }
}

ColumnStore.registerColumnType(TaskScheduledColumn);
